export default __webpack_public_path__ + "static/media/logo3Xpng.a4f32fdb.png";